import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText, Box, CircularProgress } from '@mui/material';

export interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  content?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = 'Conferma',
  content = 'Sei sicuro di voler procedere?',
  confirmText = 'Conferma',
  cancelText = 'Annulla',
  loading = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {typeof content === 'string' ? <DialogContentText>{content}</DialogContentText> : content}
      </DialogContent>
      <DialogActions>
        <Box sx={{ pb: 2, pr: 2 }}>
          <Button onClick={onCancel} color="inherit">
            {cancelText}
          </Button>
          <Button
            sx={{ ml: 2 }}
            onClick={onConfirm}
            color="error"
            variant="contained"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}
          >
            {loading ? 'Attendere...' : confirmText}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};


